<as-split direction="horizontal">
    <as-split-area class="left-area flex-left" [size]="50">
      <div>
        <mat-card class="wrapper mat-card-grow margin-5" *ngIf="!isExistingFittingSizesExtended">
            <div align="right">
                <a (click)="expandAddedFittingSizezComponent()" matTooltip="Swap verticaly">
                    <em class="material-icons">swap_vert</em>
                </a>
            </div>
            <mat-card-title style="color : #faa200;">Pending Requests For Approval</mat-card-title>
            <app-generic-table class="add-fitting" [sharedDataService]="genericTableDataService" [itemsPerPage]="4" [hasRowDisabledFunctionality]="false" [hasFilter]="true" (clickRow)=getExistingFittingSizes($any($event)) (contextMenuClick)=onAddContextMenuClick($event)
                [isAddedFittingSizesExpended]="isAddedFittingSizesExpended" [selectedRowCopy]="selectedRowCopy"></app-generic-table>
            <div style="visibility: hidden; position: fixed" [style.left]="onAddContextMenuPosition.x" [style.top]="onAddContextMenuPosition.y" [matMenuTriggerFor]="onAddContextMenu">
            <mat-menu #onAddContextMenu="matMenu">
                <ng-template matMenuContent let-element="element">
                    <button mat-menu-item (click)="onRejectActionClick(element)">
            Reject
          </button>
                    <button mat-menu-item (click)="onApproveActionClick(element)">
            Approve
          </button>
                </ng-template>
            </mat-menu>
          </div>
        </mat-card>
        <mat-card class="wrapper mat-card-grow margin-5" *ngIf="!isAddedFittingSizesExpended">
            <div align="right">
                <a (click)="expandExistingFittingSizezComponent()" matTooltip="Swap verticaly">
                    <em class="material-icons">swap_vert</em>
                </a>
            </div>
            <mat-card-subtitle>Existing fitting sizes</mat-card-subtitle>
            <app-generic-table [resetTableSubject]="resetExistingTableSubject" class="fitting-status-management-fittingSize" [hasFilter]="false" [sharedDataService]="fittingSizeDataService" [hasRowDisabledFunctionality]="false" [isExistingFittingSizesExtended]="isExistingFittingSizesExtended">
            </app-generic-table>
        </mat-card>
      </div>
    </as-split-area>
    <as-split-area class="right-area" [size]="50">
        <as-split direction="vertical">
            <mat-card class="wrapper mat-card-grow margin-5">
                <div>
                    <mat-card-subtitle>Added/Deleted/Updated sizes</mat-card-subtitle>
                    <div class="expand-newfittings-table-content">
                        <div *ngIf="getFittingType()===2 || getFittingType()=== 4">
                            <app-piping-plumbing-fitting-size [showButtons]="false" [partialSaveActionType]="getPartialSaveActionType()" [sendForAprovalActionType]="getSentForAproveActionType()" [deleteActionType]="getDeleteActionType()">
                            </app-piping-plumbing-fitting-size>
                        </div>
                        <div *ngIf="getFittingType()===5">
                            <app-sheet-metal-fitting-size [showButtons]="false" [partialSaveActionType]="getPartialSaveActionType()" [sendForAprovalActionType]="getSentForAproveActionType()" [deleteActionType]="getDeleteActionType()">
                            </app-sheet-metal-fitting-size>
                        </div>
                        <div *ngIf="getFittingType()===9">
                            <app-cable-trays [showButtons]="true" [partialSaveActionType]="getPartialSaveActionType()" [sendForAprovalActionType]="getSentForAproveActionType()" [deleteActionType]="getDeleteActionType()">
                            </app-cable-trays>
                        </div>
                    </div>
                </div>
            </mat-card>
        </as-split>
    </as-split-area>
</as-split>
